module.exports = {"330602001":"塔山街道","330602002":"府山街道","330602003":"蕺山街道","330602004":"北海街道","330602005":"城南街道","330602006":"稽山街道","330602007":"迪荡街道","330602100":"东湖镇","330602101":"灵芝镇","330602102":"东浦镇","330602103":"鉴湖镇","330602104":"皋埠镇","330602105":"马山镇","330602106":"斗门镇","330602107":"孙端镇","330602108":"富盛镇","330602109":"陶堰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330602.json
// module id = 912
// module chunks = 0